import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { Section, Box, Text } from "../../components/Core";

const Number = styled.h2`
  font-size: 3.5rem;
  font-weight: 700;
  letter-spacing: -2px;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0;
  line-height: 1;
`;

const Stats = () => (
  <Section>
    <Container>
      <Row className="text-center justify-content-center">
        <Col xs="6" lg="3" className="mb-5 mb-lg-0" data-aos="fade-up" data-aos-delay="100">
          <Box>
            <Number>9+</Number>
            <Text variant="tag" className="mt-3">Years of experience</Text>
          </Box>
        </Col>
        <Col xs="6" lg="3" className="mb-5 mb-lg-0" data-aos="fade-up" data-aos-delay="200">
          <Box>
            <Number>10+</Number>
            <Text variant="tag" className="mt-3">Projects delivered</Text>
          </Box>
        </Col>
        <Col xs="6" lg="3" className="mb-5 mb-lg-0" data-aos="fade-up" data-aos-delay="300">
          <Box>
            <Number>4K+</Number>
            <Text variant="tag" className="mt-3">Active users in production</Text>
          </Box>
        </Col>
        <Col xs="6" lg="3" data-aos="fade-up" data-aos-delay="400">
          <Box>
            <Number>&lt;2h</Number>
            <Text variant="tag" className="mt-3">Critical incident response</Text>
          </Box>
        </Col>
      </Row>
    </Container>
  </Section>
);

export default Stats;
